import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { haptic, type HapticPattern } from '../lib/haptic';

type Accent = 'amber' | 'mint' | 'coral' | 'violet' | 'ghost';

interface DarkButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  accent?: Accent;
  children: ReactNode;
  full?: boolean;
  hapticKind?: HapticPattern;
}

const STYLES: Record<Accent, string> = {
  amber:
    'bg-amber text-base shadow-glow-amber hover:brightness-110 border border-amber-600',
  mint:
    'bg-mint text-base shadow-glow-mint hover:brightness-110 border border-mint-dim',
  coral:
    'bg-coral text-white shadow-glow-coral hover:brightness-110 border border-coral-dim',
  violet:
    'bg-violet text-white shadow-glow-violet hover:brightness-110 border border-violet-dim',
  ghost:
    'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50 dark:bg-surface dark:text-ink dark:border-white/10 dark:hover:bg-white/5',
};

export default function DarkButton({
  accent = 'amber',
  children,
  full = false,
  hapticKind = 'tap',
  onClick,
  className = '',
  ...rest
}: DarkButtonProps) {
  return (
    <button
      type="button"
      onClick={(e) => {
        haptic(hapticKind);
        onClick?.(e);
      }}
      className={`inline-flex items-center justify-center gap-2 rounded-2xl px-6 py-3 font-marker text-lg tracking-wide transition-transform duration-100 active:scale-[0.96] disabled:opacity-50 disabled:cursor-not-allowed ${STYLES[accent]} ${full ? 'w-full' : ''} ${className}`}
      {...rest}
    >
      {children}
    </button>
  );
}
